export const BreSocialRate = {
  BASE_VIDEO: '315',
  AERIAL: '265',
  INTRO: '50',
  VOICEOVER: '125',
  NARRATION: '50',
  RUSH: '200',
};
